/*
<summary>
   This functional component is all about rendering the Import Tool Management form for uploading a CSV/Excel file and showing duplicate record feedback.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IImportToolManagement } from '../../../models/forms/IImportToolManagement';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import FormikFormFileInput from '../../../shared-components/FormikFormHandlers/FormikFormFileInput';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

type IProps = IAddEditFormProps<IImportToolManagement>;

const ImportToolManagementForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (values) => {
          props.submitHandler(values);
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} contained />
              ) : null}
              <Modal.Body className="overflow-y-auto">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style  col-form-label"
                        required={true}
                        label="file"
                      />
                      <Field
                        data-testid="csvFile"
                        className="form-control"
                        name="csvFile"
                        value={undefined}
                        invalidcharacter={[' ']}
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        placeholder=""
                        accept=".csv"
                        as={FormikFormFileInput}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          if (event.target.files != null && event.target.files.length > 0) {
                            const selectedFile = event.target.files[0];
                            if (!selectedFile.name.toLowerCase().endsWith('.csv')) {
                              toast.error(formatMessage('InvalidCsvFormat'));
                              event.target.value = '';
                              setFieldValue('csvFile', null);
                              return;
                            }
                            setFieldValue('csvFile', selectedFile);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ImportToolManagementForm;
